var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTBank = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    viewBox: "0 0 164 54",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16679_20417)"
  }, /*#__PURE__*/React.createElement("mask", {
    height: 54,
    id: "mask0_16679_20417",
    maskUnits: "userSpaceOnUse",
    width: 164,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.5 0H0.5V54H163.5V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16679_20417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.324 0H7.67562C3.71263 0 0.5 2.71136 0.5 6.056V47.944C0.5 51.2886 3.71263 54 7.67562 54H156.324C160.287 54 163.5 51.2886 163.5 47.944V6.056C163.5 2.71136 160.287 0 156.324 0Z",
    fill: "#FFDD2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2698 26.035C79.463 25.773 78.4077 25.6945 77.2594 25.6945H70.8656V24.018H81.8528V21.1367H66.3652V33.6052H76.8558C78.3147 33.6052 79.4007 33.5004 80.2078 33.2383C81.9149 32.6882 83.0632 31.3524 83.0632 29.5974C83.0632 27.8163 81.9769 26.5851 80.2698 26.035ZM78.0352 30.357C77.787 30.4357 77.4455 30.4618 77.0108 30.4618H70.8656V28.4711H77.0108C77.5076 28.4711 77.9109 28.4974 78.2215 28.6283C78.5938 28.7854 78.7801 29.0736 78.7801 29.4402C78.7801 29.8069 78.5629 30.1998 78.0352 30.357Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6808 21.1367H89.1011L83.0488 33.6052H88.139L88.9769 31.7977H95.805L96.6741 33.6052H101.733L95.6808 21.1367ZM90.0942 29.0473L92.2359 24.018H92.5772L94.7188 29.0473H90.0942Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.526 28.9689V33.6052H103.025V21.1367H107.526V25.6945H114.757V21.1367H119.258V33.6052H114.757V28.9689H107.526Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.381 28.8903V33.6052H121.881V21.1367H126.381V25.8255H127.623L133.054 21.1367H138.703L131.502 27.109L138.982 33.6052H132.992L127.623 28.8903H126.381Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0449 13.1211H57.9233V28.3499C57.9233 32.2538 55.4556 35.8614 51.4498 37.8136L39.9841 43.4013L28.5184 37.8136C24.5126 35.8614 22.0449 32.2538 22.0449 28.3499V13.1211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M31.8906 21.1367V25.8732C32.6581 25.1418 34.0534 24.6468 35.6488 24.6468H37.3825V30.1529C37.3825 31.6177 36.9109 32.8999 36.2112 33.6052H43.7526C43.0543 32.8992 42.5838 31.6187 42.5838 30.1557V24.6468H44.3176C45.913 24.6468 47.3083 25.1418 48.0758 25.8732V21.1367H31.8906Z",
    fill: "#333333",
    fillRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16679_20417"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 54,
    transform: "translate(0.5)",
    width: 163
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTBank);
export default ForwardRef;